import script from "./Around.vue?vue&type=script&setup=true&lang=js"
export * from "./Around.vue?vue&type=script&setup=true&lang=js"

import "./Around.vue?vue&type=style&index=0&id=bc1188f6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bc1188f6"]])

export default __exports__